// extracted by mini-css-extract-plugin
export default {"menuItem":"menu_menuItem__l8vky"};